<template>
  <div id="dashboard">
    <!--begin::Row-->
    <b-row class="mt-0 mt-lg-3" v-if="isProfileLoaded && isUserLoaded">
      <b-col cols xl="4" md="12">
        <gauge
          :title="$t('messages.dashboard.status.punctuation')"
          :value="progress ? progress * 10 : false"
          :sameheight="false"
          :background="true"
        />
      </b-col>
      <b-col cols xl="4" md="12">
        <archetype
          :archetype="archetype"
          :svg="archetypeSvg"
          :archetypeId="archetypeId"
          :sameheight="true"
          v-if="archetypeId"
        />
        <session-status v-else />
      </b-col>
      <b-col cols xl="4" md="12">
        <user :username="fullname" />
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="4" md="12">
        <status
          :cybersecurity="cybersecurity.average"
          :wellbeing="wellbeing.average"
          :abs="pwnedLevel"
          v-if="this.isProfileLoaded"
        />
      </b-col>

      <b-col lg="4" md="12">
        <sessions-timeline :sessions="sessions" :selectable="true" />
      </b-col>

      <b-col lg="4" md="12">
        <alerts :data="alerts" />
      </b-col>
    </b-row>
    <!--end::Row-->
    <!--begin::Row-->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import User from "@/components/profile/User.component";
import Gauge from "@/components/profile/Gauge.component";
import Status from "@/components/dashboard/Status.component";
import Alerts from "@/components/dashboard/Alerts.component";
import SessionsTimeline from "@/components/dashboard/SessionsTimeline.component";
import Archetype from "@/components/profile/Archetype.component";
import SessionStatus from "@/components/profile/SessionStatus.component";

export default {
  name: "Dashboard",
  components: {
    Status,
    SessionsTimeline,
    User,
    Archetype,
    Gauge,
    Alerts,
    SessionStatus
  },
  data() {
    return {
      test: false
    };
  },
  computed: {
    ...mapGetters("User", [
      "isUserLoaded",
      "progress",
      "sessions",
      "fullname",
      "archetypeSvg",
      "archetypeId"
    ]),
    ...mapGetters("Profile", [
      "isProfileLoaded",
      "wellbeing",
      "cybersecurity",
      "pwnedLevel",
      "archetype",
      "progress",
      "alerts"
    ]),
    ...mapGetters("Constants", ["isConstantsActive", "getConstant"]),
    familyType() {
      if (parseInt(this.archetypeId) >= 92 && parseInt(this.archetypeId) <= 99)
        return "creators";
      else if (
        parseInt(this.archetypeId) >= 100 &&
        parseInt(this.archetypeId) <= 107
      )
        return "defenders";
      else if (
        parseInt(this.archetypeId) >= 76 &&
        parseInt(this.archetypeId) <= 83
      )
        return "explorers";
      else if (
        parseInt(this.archetypeId) >= 84 &&
        parseInt(this.archetypeId) <= 91
      )
        return "influencers";
      else return "";
    }
  },
  methods: {
    ...mapActions("Profile", ["loadProfile"]),
    ...mapActions("Auth", ["changeDefaultView"])
  },
  mounted() {
    if (this.isConstantsActive && !this.isProfileLoaded) this.loadProfile();
    this.changeDefaultView("Dashboard");
  },
  watch: {
    isConstantsActive(value) {
      if (value === true) this.loadProfile();
    },
    isProfileLoaded(value) {
      if (this.isConstantsActive && value === false) this.loadProfile();
    }
  }
};
</script>
